const sizeGuide = new Swiper('.swiper.steps-container', {
    slidesPerView: 1.45,
    spaceBetween: 15,
    slidesOffsetBefore: 23,
    slidesOffsetAfter: 23,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 15,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      }
    },
});

const sizeSlider = new Swiper('.swiper.slider-container', {
  slidesPerView: 1,
  spaceBetween: 35,
  loop: true,
  preloadImages: false,
  lazy: true,
  navigation: {
    nextEl: '.swiper-button-next.slider',
    prevEl: '.swiper-button-prev.slider',
  },
});